

















import Menu from './components/Menu.vue';
import Solve from './components/Solve.vue';
import Stat from './components/Stat.vue';
import QrCode from './components/QrCode.vue';
import store from './store';

store.init();

export default {
  components: { Menu, Stat, Solve, QrCode },
  data: () => ({
    store,
  }),
};
